




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { getImgUrl } from '../utils/dummy';
import {
  TimelineMax,
  CSSPlugin,
  CSSRulePlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo
} from 'gsap/all';

import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

@Component({
  name: 'Gtrack'
})
export default class Gtrack extends Vue {
  // @Prop() private msg!: string;
  GtrackImg: string = 'dummy/gtrack.jpg';
  getImgUrl = getImgUrl;

  public gtrack() {
    let trackImg = document.querySelector('.track-img > picture > img');
    let tl3 = new TimelineMax({});
    tl3
      .fromTo(
        trackImg,
        1.5,
        { height: 0 },
        { height: '100%', ease: Expo.easeInOut }
      )
      .fromTo(
        '.track-text',
        1.5,
        { opacity: 0 },
        { opacity: 1, ease: Expo.easeInOut },
        '-=1.25'
      );

    const controller = new ScrollMagic.Controller();

    const scene: any = new ScrollMagic.Scene({
      triggerElement: '.track-text',
      offset: 150,
      reverse: false,
      triggerHook: 'onEnter'
    })
      .setTween(tl3)
      .addTo(controller);
  }

  public mounted() {
    this.gtrack();
  }
}
